// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    OAuthLoginTokenResponse,
    OAuthRevokeTokenRequest,
    OAuthStandardTokenRequest,
    OAuthStandardTokenResponse,
    ObjectNoResponse,
    OAuthRevokeTokenRequestToJSON,
    OAuthStandardTokenRequestToJSON,
    OAuthLoginTokenResponseFromJSON,
    OAuthStandardTokenResponseFromJSON,
    ObjectNoResponseFromJSON,
} from '../models';

export interface AuthV2AuthorizationRequest {
    clientId: string;
    redirectUri: string;
    clientSecret?: string;
    responseType?: string;
    state?: string;
}

export interface AuthV2TokenExchangeRequest {
    grantType?: string;
    clientId?: string;
    clientSecret?: string;
    code?: string;
    redirectUri?: string;
}

export interface OauthLoginTokenRequest {
    grantType?: string;
    clientId?: string;
    clientSecret?: string;
    username?: string;
    password?: string;
    invitationCode?: string;
    scope?: string;
    redirectUri?: string;
}

export interface OauthRevokeTokenRequest {
    oAuthRevokeTokenRequest?: OAuthRevokeTokenRequest;
}

export interface OauthStandardTokenRequest {
    oAuthStandardTokenRequest: OAuthStandardTokenRequest;
}

export interface OauthTemporaryTokenExchangeRequest {
    oAuthStandardTokenRequest: OAuthStandardTokenRequest;
}

/**
 * no description
 */
export class OAuthApi extends runtime.BaseAPI {

    /**
     * V2 OAuth Authorization link
     * V2 OAuth Authorization link
     */
    async authV2AuthorizationRaw(requestParameters: AuthV2AuthorizationRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['clientId'] === null || requestParameters['clientId'] === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling authV2Authorization.');
        }

        if (requestParameters['redirectUri'] === null || requestParameters['redirectUri'] === undefined) {
            throw new runtime.RequiredError('redirectUri','Required parameter requestParameters.redirectUri was null or undefined when calling authV2Authorization.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['client_id'] = requestParameters.clientId;
        }

        if (requestParameters.clientSecret !== undefined) {
            queryParameters['client_secret'] = requestParameters.clientSecret;
        }

        if (requestParameters.responseType !== undefined) {
            queryParameters['response_type'] = requestParameters.responseType;
        }

        if (requestParameters.redirectUri !== undefined) {
            queryParameters['redirect_uri'] = requestParameters.redirectUri;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/v2/authorize`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * V2 OAuth Authorization link
     * V2 OAuth Authorization link
     */
    async authV2Authorization(requestParameters: AuthV2AuthorizationRequest): Promise<string> {
        const response = await this.authV2AuthorizationRaw(requestParameters);
        return await response.value();
    }

    /**
     * V2 OAuth Token Exchange
     * V2 OAuth Token Exchange
     */
    async authV2TokenExchangeRaw(requestParameters: AuthV2TokenExchangeRequest): Promise<runtime.ApiResponse<OAuthStandardTokenResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/x-www-form-urlencoded';

        const formData = new Map<string, string>();
        if (requestParameters.grantType !== undefined) {
            formData.set('grant_type', requestParameters.grantType);
        }

        if (requestParameters.clientId !== undefined) {
            formData.set('client_id', requestParameters.clientId);
        }

        if (requestParameters.clientSecret !== undefined) {
            formData.set('client_secret', requestParameters.clientSecret);
        }

        if (requestParameters.code !== undefined) {
            formData.set('code', requestParameters.code);
        }

        if (requestParameters.redirectUri !== undefined) {
            formData.set('redirect_uri', requestParameters.redirectUri);
        }

        const response = await this.request({
            path: `/auth/v2/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formData,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthStandardTokenResponseFromJSON(jsonValue));
    }

    /**
     * V2 OAuth Token Exchange
     * V2 OAuth Token Exchange
     */
    async authV2TokenExchange(requestParameters: AuthV2TokenExchangeRequest): Promise<OAuthStandardTokenResponse> {
        const response = await this.authV2TokenExchangeRaw(requestParameters);
        return await response.value();
    }

    /**
     * The login project will use this to create an OAuth Access Code to return to the client going through the standard PKCE flow.
     * OAuth Login Project Token Endpoint
     */
    async oauthLoginTokenRaw(requestParameters: OauthLoginTokenRequest): Promise<runtime.ApiResponse<OAuthLoginTokenResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/x-www-form-urlencoded';

        const formData = new Map<string, string>();
        if (requestParameters.grantType !== undefined) {
            formData.set('grant_type', requestParameters.grantType);
        }

        if (requestParameters.clientId !== undefined) {
            formData.set('client_id', requestParameters.clientId);
        }

        if (requestParameters.clientSecret !== undefined) {
            formData.set('client_secret', requestParameters.clientSecret);
        }

        if (requestParameters.username !== undefined) {
            formData.set('username', requestParameters.username);
        }

        if (requestParameters.password !== undefined) {
            formData.set('password', requestParameters.password);
        }

        if (requestParameters.invitationCode !== undefined) {
            formData.set('invitation_code', requestParameters.invitationCode);
        }

        if (requestParameters.scope !== undefined) {
            formData.set('scope', requestParameters.scope);
        }

        if (requestParameters.redirectUri !== undefined) {
            formData.set('redirect_uri', requestParameters.redirectUri);
        }

        const response = await this.request({
            path: `/oauth/login_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formData,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthLoginTokenResponseFromJSON(jsonValue));
    }

    /**
     * The login project will use this to create an OAuth Access Code to return to the client going through the standard PKCE flow.
     * OAuth Login Project Token Endpoint
     */
    async oauthLoginToken(requestParameters: OauthLoginTokenRequest): Promise<OAuthLoginTokenResponse> {
        const response = await this.oauthLoginTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     * OAuth Revoke Token Endpoint
     * OAuth Revoke Token Endpoint
     */
    async oauthRevokeTokenRaw(requestParameters: OauthRevokeTokenRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/oauth/revoke_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthRevokeTokenRequestToJSON(requestParameters['oAuthRevokeTokenRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * OAuth Revoke Token Endpoint
     * OAuth Revoke Token Endpoint
     */
    async oauthRevokeToken(requestParameters: OauthRevokeTokenRequest): Promise<ObjectNoResponse> {
        const response = await this.oauthRevokeTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     * OAuth Standard Token Endpoint
     * OAuth Standard Token Endpoint
     */
    async oauthStandardTokenRaw(requestParameters: OauthStandardTokenRequest): Promise<runtime.ApiResponse<OAuthStandardTokenResponse>> {
        if (requestParameters['oAuthStandardTokenRequest'] === null || requestParameters['oAuthStandardTokenRequest'] === undefined) {
            throw new runtime.RequiredError('oAuthStandardTokenRequest','Required parameter requestParameters.oAuthStandardTokenRequest was null or undefined when calling oauthStandardToken.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/oauth/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthStandardTokenRequestToJSON(requestParameters['oAuthStandardTokenRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthStandardTokenResponseFromJSON(jsonValue));
    }

    /**
     * OAuth Standard Token Endpoint
     * OAuth Standard Token Endpoint
     */
    async oauthStandardToken(requestParameters: OauthStandardTokenRequest): Promise<OAuthStandardTokenResponse> {
        const response = await this.oauthStandardTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     * OAuth Temporary Token Exchange Endpoint
     * OAuth Temporary Token Exchange Endpoint
     */
    async oauthTemporaryTokenExchangeRaw(requestParameters: OauthTemporaryTokenExchangeRequest): Promise<runtime.ApiResponse<OAuthStandardTokenResponse>> {
        if (requestParameters['oAuthStandardTokenRequest'] === null || requestParameters['oAuthStandardTokenRequest'] === undefined) {
            throw new runtime.RequiredError('oAuthStandardTokenRequest','Required parameter requestParameters.oAuthStandardTokenRequest was null or undefined when calling oauthTemporaryTokenExchange.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/oauth/temporary_token_exchange`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthStandardTokenRequestToJSON(requestParameters['oAuthStandardTokenRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthStandardTokenResponseFromJSON(jsonValue));
    }

    /**
     * OAuth Temporary Token Exchange Endpoint
     * OAuth Temporary Token Exchange Endpoint
     */
    async oauthTemporaryTokenExchange(requestParameters: OauthTemporaryTokenExchangeRequest): Promise<OAuthStandardTokenResponse> {
        const response = await this.oauthTemporaryTokenExchangeRaw(requestParameters);
        return await response.value();
    }

}
